/** Benefit cards — outcome-led, no invented stats. */
import { CalendarDays, ClipboardCheck, FolderOpen, PoundSterling, Users } from 'lucide-react';

const BENEFITS = [
  { icon: CalendarDays, title: 'Simple scheduling', text: 'Build and manage staff rotas from one place.' },
  { icon: ClipboardCheck, title: 'Clear attendance', text: 'See scheduled hours and actual attendance clearly.' },
  { icon: PoundSterling, title: 'Easier payroll', text: 'Review and finalise employee hours before payroll.' },
  { icon: Users, title: 'Staff management', text: 'Give employees a simple way to access schedules and clock in and out.' },
  { icon: FolderOpen, title: 'One place for information', text: 'Keep restaurant announcements, procedures and important staff resources organised.' },
];

export function BenefitsSection() {
  return (
    <section className="scroll-mt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <h2 className="text-3xl sm:text-4xl font-display font-semibold tracking-tight max-w-2xl" data-testid="marketing-benefits-heading">
          Spend less time on admin. More time running your restaurant.
        </h2>
        <div className="mt-9 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-testid="marketing-benefits-grid">
          {BENEFITS.map((benefit) => (
            <article key={benefit.title} className="surface-card p-5 sm:p-6 hover:shadow-[0_10px_30px_rgba(16,24,40,0.08)] transition-shadow duration-200">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--brand-primary-soft)]">
                <benefit.icon className="h-5 w-5 text-[color:var(--brand-primary)]" aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold">{benefit.title}</h3>
              <p className="mt-1.5 text-sm text-[color:var(--brand-text-muted)] leading-relaxed">{benefit.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
